import * as z from 'zod'
import emailSchema from './emailSchema'

export const schema = emailSchema.extend({
  termCheck: z.boolean().refine((v) => v === true)
})

export default schema
